import axiosClient from "./axiosClient";

const serviceUrl = "qlkhambenh/phieu-xet-nghiem";

const analysisService = {
  getListTabAnalysis: async (params) => {
    const url = serviceUrl + `/danh-sach-phieu-xet-nghiem`;
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getDetailPatient: async (id) => {
    const url = serviceUrl + `/chi-tiet-xet-nghiem`;
    const params = { idPhieuXetNghiem: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getListSpecimen: async (id) => {
    const url = `/qlkhambenh/benh-pham/get-by-id-phieu-xet-nghiem`;
    const params = { idPhieuXetNghiem: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getListDoctor: async () => {
    const url = `/qlkhambenh/danh-sach-y-ta`;
    const response = await axiosClient.get(url);
    return response;
  },

  getListResult: async (id) => {
    const url = `/qlkhambenh/danh-sach-ket-qua-chi-so-xet-nghiem`;
    const params = { idChiDinhXetNghiem: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  postAnalysisResult: async (body) => {
    const url = `/qlkhambenh/danh-sach-ket-qua-chi-so-xet-nghiem`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getIDSpecimen: async (id) => {
    const url = `/qlkhambenh/benh-pham/sinh-ma-benh-pham?idPhieuXetNghiem=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },

  getListCategorySpecimen: async () => {
    const url = `/qlkhambenh/dm-loai-bp/list-dm-loai-bp`;
    const response = await axiosClient.get(url);
    return response;
  },

  getSpecimenById: async (id) => {
    const url = `/qlkhambenh/benh-pham/get-by-id-phieu-xet-nghiem?idPhieuXetNghiem=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },

  addListCategorySpecimen: async (body) => {
    const url = `/qlkhambenh/dm-loai-bp`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  editListCategorySpecimen: async (id, body) => {
    const url = `/qlkhambenh/dm-loai-bp?id=${id}`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  deleteCategorySpecimen: async (id) => {
    const url = `/qlkhambenh/dm-loai-bp?id=${id}`;
    const response = await axiosClient.delete(url);
    return response;
  },

  getListCategoryDVT: async () => {
    const url = `/qlkhambenh/dm-dvt-bp/list-dm-dvt-bp`;
    const response = await axiosClient.get(url);
    return response;
  },

  addCategoryDVT: async (body) => {
    const url = `/qlkhambenh/dm-dvt-bp`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  editCategoryDVT: async (id, body) => {
    const url = `/qlkhambenh/dm-dvt-bp?id=${id}`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  deleteCategoryDVT: async (id) => {
    const url = `/qlkhambenh/dm-dvt-bp?id=${id}`;
    const response = await axiosClient.delete(url);
    return response;
  },

  getListCategoryIndexById: async (id) => {
    const url = `/qlkhambenh/dm-chi-so-xet-nghiem/get-by-id-chi-dinh-xet-nghiem`;
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getListCategoryIndex: async () => {
    const url = `/qlkhambenh/dm-chi-so-dich-vu`;
    const response = await axiosClient.get(url);
    return response;
  },

  addCategoryIndex: async (body) => {
    const url = `/qlkhambenh/dm-chi-so-dich-vu`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  editCategoryIndex: async (id, body) => {
    const url = `/qlkhambenh/dm-chi-so-dich-vu?id=${id}`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  deleteCategoryIndex: async (id) => {
    const url = `/qlkhambenh/dm-chi-so-dich-vu?id=${id}`;
    const response = await axiosClient.delete(url);
    return response;
  },

  getListCategoryIndexAnalysis: async () => {
    const url = `/qlkhambenh/dm-chi-so-xet-nghiem`;
    const response = await axiosClient.get(url);
    return response;
  },

  addCategoryIndexAnalysis: async (body) => {
    const url = `/qlkhambenh/dm-chi-so-xet-nghiem`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  editCategoryIndexAnalysis: async (id, body) => {
    const url = `/qlkhambenh/dm-chi-so-xet-nghiem?id=${id}`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  deleteCategoryIndexAnalysis: async (id) => {
    const url = `/qlkhambenh/dm-chi-so-xet-nghiem?id=${id}`;
    const response = await axiosClient.delete(url);
    return response;
  },

  getSearchDataDV: async (value) => {
    const url = `/qlkhambenh/dm-dich-vu/search-dm-dich-vu?tenDichVu=${value}`;
    const response = await axiosClient.get(url);
    return response;
  },

  getSearchDataCS: async (value) => {
    const url = `/qlkhambenh/dm-chi-so-xet-nghiem/search-dm-chi-so-xet-nghiem?tenChiSo=${value}`;
    const response = await axiosClient.get(url);
    return response;
  },

  putAnalysisResult: async (body) => {
    const url = `/qlkhambenh/danh-sach-ket-qua-chi-so-xet-nghiem`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  putTakeSamples: async (body) => {
    const url = `/qlkhambenh/chi-dinh-xet-nghiem/cap-nhat-lay-mau`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  saveSpecimens: async (body) => {
    const url = `/qlkhambenh/benh-pham`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  saveAnalysisResult: async (body) => {
    const url = `/qlkhambenh/chi-dinh-xet-nghiem/cap-nhat-lay-mau`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  saveResult: async (id, body) => {
    const url = `/qlkhambenh/chi-dinh-xet-nghiem/luu-ket-qua?id=${id}`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  submitAnalysisResult: async (body) => {
    const url = `/qlkhambenh/chi-dinh-xet-nghiem/duyet-ket-qua`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  getListMachine: async () => {
    const url = `/qlkhambenh/danh-sach-may-xet-nghiem`;
    const response = await axiosClient.get(url);
    return response;
  },

  getListMethod: async () => {
    const url = `/qlkhambenh/danh-sach-phuong-phap-xet-nghiem`;
    const response = await axiosClient.get(url);
    return response;
  },

  deleteTicketAnalysis: async (id) => {
    const params = { id: id };
    const response = await axiosClient.delete(serviceUrl, { params: params });
    return response;
  },

  updateStatusPCDXN: async (id, status, nvThucHien, truongKhoaXetNghiem) => {
    const url = `/qlkhambenh/phieu-xet-nghiem/cap-nhat-trang-thai?id=${id}&trangThai=${status}&nvThucHien=${nvThucHien}&truongKhoaXetNghiem=${truongKhoaXetNghiem}`;
    const response = await axiosClient.put(url);
    return response;
  },

  saveStatus: async (
    id,
    status,
    name,
    nguoiDuyetKetQua,
    truongKhoaXetNghiem
  ) => {
    const url = `/qlkhambenh/phieu-xet-nghiem/cap-nhat-trang-thai?id=${id}&trangThai=${status}&nvThucHien=${name}&nguoiDuyetKetQua=${nguoiDuyetKetQua}&truongKhoaXetNghiem=${truongKhoaXetNghiem}`;
    const response = await axiosClient.put(url);
    return response;
  },

  updateStatus: async (id, body) => {
    const url = `qlkhambenh/phieu-xet-nghiem?id=${id}`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  getDataPrintXN: async (id) => {
    const url = `/qlkhambenh/phieu-xet-nghiem-in?id=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },

  getDataPrintXNByListId: async (params) => {
    const queryParams = params.map((id) => `listIds=${id}`).join("&");
    const url = `/qlkhambenh/phieu-xet-nghiem-in-chi-tiet?${queryParams}`;
    const response = await axiosClient.get(url);
    return response;
  },

  getListKetQuaXN: async (id) => {
    const url = `/qlkhambenh/phieu-xet-nghiem/ket-qua-chi-so-xet-nghiem?id=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },

  saveListKetQuaXN: async (body) => {
    const url = `/qlkhambenh/phieu-xet-nghiem/ket-qua-chi-so-xet-nghiem`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getBookAnalysis: async (params) => {
    const url = `/qlkhambenh/so-xet-nghiem`;
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getDataExportBook: async (params) => {
    const url = `/qlkhambenh/export-so-xet-nghiem`;
    const response = await axiosClient.get(url, {
      params: params,
      responseType: "blob",
    });
    return response;
  },

  getDataMachineAnalysis: async (id, id2, thoiGian) => {
    const url = `/qlkhambenh/phieu-xet-nghiem/ket-qua-chi-so-xet-nghiem`;
    const params = { id: id, maBenhPham: id2, tgLayMau: thoiGian };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  //báo cáo thời gian xét nghiệm
  getWattingReportAnalysis: async (params) => {
    const url = `/qlkhambenh/phieu-xet-nghiem/bao-cao-thoi-gian-xet-nghiem`;
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
};

export default analysisService;
